import { useState } from "react";
import TurnstileWidget from "./TurnstileWidget";

const TIPOLOGIE = ["Bilocale", "Trilocale", "Quadrilocale", "Attico"];

export default function ContactForm({ onSuccessAnimation }) {
  const [sent, setSent] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");
  const [turnstileToken, setTurnstileToken] = useState("");
  const [turnstileResetKey, setTurnstileResetKey] = useState(0);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");
    setSubmitting(true);

    try {
      const form = new FormData(event.currentTarget);
      const payload = {
        nome: form.get("nome"),
        cognome: form.get("cognome"),
        email: form.get("email"),
        telefono: form.get("telefono"),
        tipologia: form.get("tipologia"),
        comune: form.get("comune"),
        privacyConsent: form.get("privacy") === "on",
        marketingConsent: form.get("marketing") === "on",
        turnstileToken,
      };

      const response = await fetch("/api/leads", {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await response.json().catch(() => ({}));

      if (!response.ok || !data.ok) {
        throw new Error(data.error || "Non è stato possibile inviare la richiesta.");
      }

      if (onSuccessAnimation) {
        await onSuccessAnimation();
      }

      setSent(true);
    } catch (err) {
      setError(err.message || "Non è stato possibile inviare la richiesta.");
      setTurnstileToken("");
      setTurnstileResetKey((value) => value + 1);
    } finally {
      setSubmitting(false);
    }
  };

  if (sent) {
    return (
      <section className="form-card form-success">
        <h2 className="success-title">Grazie per averci contattato</h2>
        <p className="success-text">
          Abbiamo registrato la tua richiesta. Il nostro team ti ricontatterà al più presto.
        </p>
      </section>
    );
  }

  return (
    <form className="form-card" onSubmit={handleSubmit}>
      <div className="form-grid">
        <Field label="Nome">
          <input name="nome" type="text" autoComplete="given-name" placeholder="Mario" required />
        </Field>
        <Field label="Cognome">
          <input name="cognome" type="text" autoComplete="family-name" placeholder="Rossi" required />
        </Field>
        <Field label="Email">
          <input name="email" type="email" autoComplete="email" placeholder="mario.rossi@email.it" required />
        </Field>
        <Field label="Numero di telefono">
          <input name="telefono" type="tel" autoComplete="tel" placeholder="+39 333 000 0000" required />
        </Field>
        <Field label="Tipologia">
          <select name="tipologia" required defaultValue="">
            <option value="" disabled>Seleziona</option>
            {TIPOLOGIE.map((type) => <option key={type} value={type}>{type}</option>)}
          </select>
        </Field>
        <Field label="Comune di residenza">
          <input name="comune" type="text" autoComplete="address-level2" placeholder="Città" required />
        </Field>
      </div>

      <div className="consent-group">
        <label className="privacy-row">
          <input name="privacy" type="checkbox" required className="privacy-box" />
          <span>
            Dichiaro di aver letto l&rsquo;
            <a href="/privacy" target="_blank" rel="noopener noreferrer">informativa privacy</a>
            {" "}sul trattamento dei dati personali.
          </span>
        </label>

        <label className="privacy-row privacy-row--optional">
          <input name="marketing" type="checkbox" className="privacy-box" />
          <span>
            Acconsento a ricevere da Immobiliare Ciurriero e dai suoi partners comunicazioni commerciali
            e promozionali relative a iniziative immobiliari tramite e-mail, telefono, SMS e sistemi di
            messaggistica. Il consenso è facoltativo e revocabile in qualsiasi momento.
          </span>
        </label>
      </div>

      <TurnstileWidget key={turnstileResetKey} onToken={setTurnstileToken} />

      {error && <p className="form-error" role="alert">{error}</p>}

      <button type="submit" className="submit-btn" disabled={submitting || !turnstileToken}>
        {submitting ? "Invio in corso..." : "Richiedi informazioni"}
      </button>
    </form>
  );
}

function Field({ label, children }) {
  return <label className="field"><span>{label}</span>{children}</label>;
}
